import * as R from 'ramda';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import React, { useCallback, useEffect } from 'react';
// components
import { FormFooter } from '../../../components/form-footer';
// forms
import { Fieldset2 } from '../../../forms';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// ui
import { Flex, MainActionButton } from '../../../ui';
// feature compensation-group
import { createOrUpdateCompensationGroupRequest } from '../actions';
import { Compensations, useCompensationTableActions, useGetCompensationGroupByGuid } from './compensations';
//////////////////////////////////////////////////

const fields = [
  {
    isRequired: true,
    fieldName: GC.FIELD_NAME,
    label: ['titles:name', 'Name'],
    inputWrapperStyles: { mr: 20, width: 250 },
  },
  {
    type: 'toggle',
    fieldName: GC.FIELD_ACTIVE,
    label: ['titles:active', 'active'],
    inputWrapperStyles: { width: 'max-content' },
  },
];

const CompensationGroup = ({ guid, closeModal }) => {
  const dispatch = useDispatch();

  const compensationGroup = useGetCompensationGroupByGuid(guid);

  const formik = useFormik({
    initialValues: { name: '', active: true, compensations: [] },
    validationSchema: Yup.object().shape({ [GC.FIELD_NAME]: G.yupStringRequired }),
    onSubmit: (values) => dispatch(createOrUpdateCompensationGroupRequest(values)),
  });

  const { values, setValues, handleSubmit } = formik;

  const { compensations } = values;

  const groupHasCompensations = G.isNotNilAndNotEmpty(R.prop('compensations', compensationGroup));

  useEffect(() => {
    if (groupHasCompensations) setValues(compensationGroup);
  }, [groupHasCompensations]);

  const setCompensations = useCallback((value, { successCallback, shouldCloseModal } = {}) => {
    setValues((prevValues) => {
      const { compensations } = prevValues;

      let newCompensations;

      if (G.isString(value)) {
        newCompensations = R.reject(R.propEq(value, GC.FIELD_ID), compensations);
      } else {
        const { id } = value;

        const index = R.findIndex(R.propEq(id, GC.FIELD_ID), compensations);

        if (R.equals(index, -1)) {
          newCompensations = R.append(value, compensations);
        } else {
          newCompensations = R.assocPath([index], value, compensations);
        }
      }

      return {
        ...prevValues,
        compensations: newCompensations,
      };
    });

    G.callFunctionWithArgs(successCallback, G.genShortId());

    if (shouldCloseModal) closeModal();
  }, []);

  const {
    actionButtons,
    branchConfigs,
    handleCreateOrUpdateCompensation,
  } = useCompensationTableActions({ setCompensations, compensationGroup });

  return (
    <form onSubmit={handleSubmit}>
      <Flex mb={20} pt={10}>
        <Fieldset2 {...G.getFormikProps(formik)} fields={fields} />
        <MainActionButton
          ml={20}
          type='button'
          disabled={R.isNil(branchConfigs)}
          onClick={() => handleCreateOrUpdateCompensation()}
        >
          {G.getAddTitle(['titles:compensation-details', 'Compensation Details'])}
        </MainActionButton>
      </Flex>
      <Compensations m='0px' itemList={compensations} actionButtons={actionButtons} />
      <FormFooter boxStyles={{ mt: 20 }} />
    </form>
  );
};

export default CompensationGroup;
